import PropTypes from 'prop-types';

import Checkbox from '@zenbusiness/zui/Checkbox';
import FormControl from '@zenbusiness/zui/FormControl';
import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import FormHelperText from '@zenbusiness/zui/FormHelperText';

/**
 * Single checkbox field
 * @param {object} props - Component props
 * @param {object} props.def - Field definition
 * @param {boolean} props.value - Current checkbox state
 * @param {Function} props.onChange - Change handler
 * @param {boolean} [props.disabled=false] - Whether field is disabled
 * @param {string} [props.error] - Error message to display
 */
function CheckboxField({ def, value, onChange, disabled = false, error }) {
  const handleChange = (event) => {
    onChange(event.target.checked);
  };

  const fieldId = `checkbox-${def.id}`;
  const hasError = Boolean(error);
  const isChecked = Boolean(value);

  return (
    <FormControl disabled={disabled} error={hasError} fullWidth required={def.required}>
      <FormControlLabel
        control={
          <Checkbox
            checked={isChecked}
            color="primary"
            disabled={disabled}
            id={fieldId}
            name={fieldId}
            required={def.required}
            onChange={handleChange}
          />
        }
        disabled={disabled}
        label={def.label || 'Checkbox'}
      />

      {(error || def.helpText) && <FormHelperText>{error || def.helpText}</FormHelperText>}
    </FormControl>
  );
}

CheckboxField.propTypes = {
  def: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['checkbox']).isRequired,
    label: PropTypes.string,
    helpText: PropTypes.string,
    required: PropTypes.bool
  }).isRequired,
  value: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  error: PropTypes.string
};

export default CheckboxField;
